import {
  ButtonProps,
  Icon as CIcon,
  IconProps as CIconProps,
  Flex,
  FlexProps,
  useStyleConfig,
} from '@chakra-ui/react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { ReactElement, ReactNode } from 'react';

export interface IconBoxProps extends FlexProps {
  size?: ButtonProps['size'];
  children: ReactNode;
}

export const IconBox = ({ size, ...rest }: IconBoxProps): ReactElement | null => {
  const styles = useStyleConfig('IconBox', { size });
  return <Flex __css={styles} {...rest} />;
};

export type IconProps = CIconProps & Omit<FontAwesomeIconProps, 'display' | 'fontSize'>;

export const Icon = (props: IconProps): ReactElement | null => (
  <CIcon as={FontAwesomeIcon} {...props} />
);
